import {useCallback, useEffect, useState} from 'react';
import {socialFeedApi, TrendingTopic} from '../../../../services/socialFeedApi';
import {isRequestCanceled} from '../utils';

export const useHomeTrendingTopics = (token: string | null) => {
  const [topics, setTopics] = useState<TrendingTopic[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const refresh = useCallback(async (signal?: AbortSignal) => {
    if (!token) {
      setTopics([]);
      setLoading(false);
      setError(null);
      return;
    }

    try {
      setLoading(true);
      setError(null);
      const response = await socialFeedApi.getTrendingTopics(token, signal);
      if (!signal?.aborted) setTopics(response.topics);
    } catch (requestError) {
      if (!isRequestCanceled(requestError)) {
        setError(requestError instanceof Error ? requestError.message : 'Failed to load trending topics');
      }
    } finally {
      if (!signal?.aborted) setLoading(false);
    }
  }, [token]);

  useEffect(() => {
    const controller = new AbortController();
    void refresh(controller.signal);
    return () => controller.abort();
  }, [refresh]);

  return {topics, loading, error, refresh};
};
